// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","onboardingMainArea":"_32EE0QqEzbRNWmGSKnNXdM","mobileOnboarding":"_1MHjN8rHmBs5_xlD5csASx"};